import { rest } from 'msw'

export const svgHandlers = [
	rest.get(/.*svg/, (req, res, ctx) => {
		return res(ctx.status(200))
	}),
]
